import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";
import { POLICIES } from "@/content/policies";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-violet/30 bg-ink px-5 pb-8 pt-20 md:px-10">
    <div className="mx-auto max-w-[1440px]">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-6">
          <LogoMark className="h-36 w-36" />
          <p data-testid="footer-tagline" className="mt-6 max-w-sm font-display text-2xl font-extrabold uppercase">Let's go <span className="text-lime">Insane</span></p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-lime">Explore</p>
          <ul className="mt-4 space-y-2 text-base">
            <li><Link data-testid="footer-shop-link" to="/#shop" className="transition-colors hover:text-lime">Shop the drop</Link></li>
            <li><Link data-testid="footer-about-link" to="/about" className="transition-colors hover:text-lime">About us</Link></li>
            {Object.entries(POLICIES).map(([slug, p]) => (
              <li key={slug}><Link data-testid={`footer-${slug}-link`} to={`/policies/${slug}`} className="transition-colors hover:text-lime">{p.title}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-lime">Contact us</p>
          <ul className="mt-4 space-y-2 break-all text-base text-haze">
            <li><a data-testid="footer-email-link" href="mailto:Insanecircleofficial@gmail.com" className="transition-colors hover:text-lime">Insanecircleofficial@gmail.com</a></li>
            <li><a data-testid="footer-instagram-link" href="https://www.instagram.com/insanecircle?mdxt=MWplZ3FscDNucnZtcw==" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-lime">@insanecircle</a></li>
          </ul>
        </div>
      </div>
      <p aria-hidden="true" className="mt-16 select-none whitespace-nowrap font-display text-[7.2vw] font-extrabold uppercase leading-[0.8] tracking-[-0.05em] text-violet/40 min-[1440px]:text-[7rem]">
        Insane Circle
      </p>
      <div className="mt-6 flex flex-col justify-between gap-2 font-mono text-xs uppercase tracking-widest text-haze md:flex-row">
        <span>© {new Date().getFullYear()} Insane Circle</span>
        <span>Made in India for the World</span>
      </div>
    </div>
  </footer>
);
